module.exports = __webpack_public_path__ + "img/ingresos_brutos.63458998.png";